export class Validation {
  constructor() {
    const form = document.querySelector('.wpcf7-form')
    if (!form) return
    jQuery(function ($) {
      // バリデーションメソッドの追加
      $.validator.addMethod(
        'furigana',
        function (value, element) {
          return this.optional(element) || /^[\u3040-\u309F\u30A0-\u30FFｧ-ﾝﾞﾟ]*$/.test(value)
        },
        'ひらがなもしくはカタカナで入力してください'
      )
      $.validator.addMethod(
        'phone',
        function (value, element) {
          if (value.includes('-')) {
            return this.optional(element) || /^\d{3}-\d{4}-\d{4}$|^\d{4}-\d{2}-\d{4}$/.test(value)
          } else {
            return this.optional(element) || /^\d{10}$|^\d{11}$/.test(value)
          }
        },
        '電話番号の形式で入力してください'
      )
      // バリデーションの初期化
      //　複数フォームある場合もまとめて以下に記述してください
      $('.wpcf7-form').validate({
        rules: {
          your_zip: { required: true },
          your_address: { required: true },
          your_name: { required: true },
          your_name_kana: { required: true, furigana: true },
          your_first_name_kana: { required: true, furigana: true },
          your_email: { required: true, email: true },
          your_email_confirm: { required: true, email: true, equalTo: '[name=your_email]' },
          your_tel: { required: true, phone: true },
          your_tel_any: { phone: true },
          your_message: { required: true },
          your_age: { required: true },
          'your_job[]': { required: true },
          your_file: { required: true },
        },
        messages: {
          your_company: {
            required: '入力必須項目です',
          },
          your_zip: {
            required: '入力必須項目です',
          },
          your_address: {
            required: '入力必須項目です',
          },
          your_name: {
            required: '入力必須項目です',
          },
          your_name_kana: {
            required: '入力必須項目です',
          },
          your_first_name_kana: {
            required: '入力必須項目です',
          },
          your_email: {
            required: 'メールアドレスを入力してください',
            email: '有効なメールアドレスを入力してください',
          },
          your_email_confirm: {
            required: 'メールアドレスを入力してください',
            email: '有効なメールアドレスを入力してください',
            equalTo: 'メールアドレスが違います',
          },
          your_tel: {
            required: '入力必須項目です',
          },
          your_message: {
            required: '入力必須項目です',
          },
          your_age: {
            required: '入力必須項目です',
          },
          'your_job[]': {
            required: '入力必須項目です',
          },
          your_file: {
            required: '入力必須項目です',
          },
        },
        errorElement: 'div',
        errorPlacement: function ($error, $element) {
          if ($element.closest('.js-error_wrap').hasClass('js-error_wrap')) {
            $element.closest('.c-form__body').append($error)
          } else {
            const isRadio = $element.attr('type') === 'radio'
            const $parent = isRadio ? $element.parent().parent().parent().parent() : $element.parent()
            const $target = $parent.find(`#${$error.attr('id')}`)
            if ($target.length) {
              $target.remove()
              $parent.append($error)
            } else {
              if (isRadio) {
                $parent.append($error)
              } else {
                $error.insertAfter($element)
              }
            }
          }
        },
      })

      const pathname = window.location.pathname
      // 送信ボタンのクリックイベント
      $('.wpcf7-submit').on('click', function (e) {
        e.preventDefault() // 最初にイベントをキャンセル

        // フォームのバリデーションを手動でトリガー
        if ($('.wpcf7-form').valid()) {
          if (!window.confirm('本当に送信しますか？')) {
            // 送信をキャンセル
            return
          }
          $('.wpcf7-form').submit()
          // 送信後のページ遷移（複数ページある場合は分岐してください）
          setTimeout(() => {
            if (pathname.includes('entry')) {
              location = '/entry/complete/'
            } else if (pathname.includes('contact')) {
              location = '/contact/complete/'
            }
          }, 100)
        } else {
          alert('入力内容に不備があります')
          $('html, body').animate(
            {
              scrollTop: $('.c-form__contents').offset().top,
            },
            500
          )
        }
      })
    })
  }
}
